import Vue from './vue';
import VueRouter from 'vue-router';
import ErrorLayout from "@milestoneslabs/milestones-ui-kit/src/views/Layouts/ErrorLayout/ErrorLayout";
import PrimaryNotFoundError from "@milestoneslabs/milestones-ui-kit/src/views/Errors/404/Primary/PrimaryNotFoundError";

Vue.use(VueRouter);

let routes = [];

const files = require.context('./routes/landing-page', true, /\.route.js$/i);

files.keys().map((key) => {
    const route = files(key).default;

    if (Array.isArray(route)) {
        return routes = routes.concat(route);
    }

    routes.push(route);
});

routes.push({
    path: '*',
    component: PrimaryNotFoundError,
    meta: {
        layout: ErrorLayout,
    },
});
const router = new VueRouter({
    base: '/',
    mode: 'history',
    routes,
    scrollBehaviour() {
        return {x: 0, y: 0};
    },
});

export default router;
